// Видео-эталоны с актрисой — те же ролики, что показывает основной
// проект EZSpeech (#logopedStream в performing_exercise.html).
//
// Лежат в публичном контейнере Selectel, которым пользуется Django-бэкенд
// основного проекта (его MEDIA-хранилище, upload_to="video/"). Контейнер
// отдаёт объекты публично и поддерживает range-запросы, поэтому ключи
// доступа приложению не нужны — ссылка прямая. Листинг контейнера при
// этом закрыт, так что имена файлов перечислены здесь явно.
//
// Ключ — slug упражнения: он одинаков и в gameRegistry (тренажёр), и в
// exerciseConfig вопросов cv_face_action (шкалы), поэтому один словарь
// обслуживает оба движка.
const BASE = process.env.REACT_APP_REFERENCE_VIDEO_BASE
  || 'https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/video/';

const FILES = {
  'open-close-mouth': '1__open_close_mouth.mp4',
  'smiley-face': '2__smile_face.mp4',
  'show-teeth': '11__show_teeth.mp4',
  'brows-up': '29__brows_up.mp4',
  'kisses': '6__kisses.mp4',
  'round-lips': '3__round_lips.mp4',
};

/** Ссылка на эталон по slug упражнения; null — если ролика нет. */
export const getReferenceVideo = (slug) => (FILES[slug] ? `${BASE}${FILES[slug]}` : null);

// В основном проекте эталон проигрывается замедленно, чтобы пациент успевал
// разглядеть артикуляцию (client.js: videoLogoped.playbackRate = 0.3).
// 0.3 там подобрано под их съёмку; здесь то же назначение.
export const REFERENCE_PLAYBACK_RATE = 0.5;

export default getReferenceVideo;
